export default function TableTitle({ title }: { title: string }) {
  return (
    <h2 className="text-spectum text-sm font-medium uppercase tracking-wide pb-2 pt-1">
      {title}
    </h2>
  );
}
